import React from 'react';

import numeral from 'numeral';
import If from '../../Shared/If/If';
import Case from '../../Shared/Switch/Case';
import Switch from '../../Shared/Switch/Switch';
import { FundNoteAdd, ProductTypes } from '../../../settings/settings';

import './NewFundSearch.scss';

const NewFundSearchSelectedFundNotes = ({
  selectedFund,
  showProspectus,
  selectedRegistrationProductType,
  scsProgram,
}) => {
  const newFundSearchChosenAgreement = 'new-fund-search-chosen-agreement';
  const newFundSearchProspectus = 'new-fund-search-prospectus';
  return (
    <>
      <If test={selectedFund.summit || selectedFund.ticker === 'TRLAX'}>
        <div
          className={`${
            scsProgram
              ? newFundSearchChosenAgreement
              : 'new-fund-search-min-contribution'
          } e2e-new-fund-min-contribution-specific`}
        >
          Minimum investment amount is{' '}
          {numeral(selectedFund.minimumInvestmentAmount).format('$0,0')}.
        </div>
      </If>
      <If
        test={
          selectedFund.notes[FundNoteAdd.RETIREMENT_INCOME_FOR_NON_IRA] ||
          selectedFund.notes[FundNoteAdd.RETIREMENT_INCOME_FOR_IRA]
        }
      >
        <div
          className={`${
            scsProgram
              ? newFundSearchChosenAgreement
              : 'new-fund-search-selected-note-style'
          }`}
        >
          Cash Dividend Distributions from the {selectedFund.name} fund will be
          distributed and deposited to your most recently added bank on file.
          Your bank selection can be changed later in your account settings. If
          you do not have a bank of file, dividends will be distributed by check
          to address on record.
        </div>
      </If>
      <If test={showProspectus}>
        <Switch test={selectedRegistrationProductType}>
          <Case value="MutualFund">
            {!scsProgram && (
              <div
                className={`${
                  scsProgram
                    ? newFundSearchChosenAgreement
                    : newFundSearchProspectus
                }`}
              >
                I have read the prospectus for the fund in which I am investing
                and agree to its terms.{' '}
                <a
                  href={`https://prospectus-express.broadridge.com/summary.asp?doctype=spro&clientid=trowepll&fundid=${selectedFund.cusip}`}
                  rel="noopener noreferrer"
                  id={`view-prospectus-${
                    selectedFund.ticker && selectedFund.ticker.toLowerCase()
                  }`}
                  target="_blank"
                >
                  View Prospectus
                </a>
              </div>
            )}
          </Case>
          <Case value={ProductTypes.MARYLAND529}>
            <div
              className={`${
                scsProgram
                  ? newFundSearchChosenAgreement
                  : newFundSearchProspectus
              }`}
            >
              I have reviewed the{' '}
              <a
                href="https://maryland529.com/Portals/0/Files/cip_disclosure.pdf"
                rel="noopener noreferrer"
                className="college-branded-link"
                target="_blank"
              >
                Plan Disclosure Statement’s
              </a>{' '}
              description for the Portfolio(s) in which I am investing and agree
              to the terms.
            </div>
          </Case>
          <Case value={ProductTypes.NATIONAL529}>
            <div
              className={`${
                scsProgram
                  ? newFundSearchChosenAgreement
                  : newFundSearchProspectus
              }`}
            >
              I have reviewed the{' '}
              <a
                href="https://individual.troweprice.com/Retail/Shared/PDFs/trp529Disclosure.pdf"
                className="college-branded-link"
                rel="noopener noreferrer"
                target="_blank"
              >
                Plan Disclosure Document's
              </a>{' '}
              description for the Portfolio(s) in which I am investing and agree
              to the terms.
            </div>
          </Case>
          <Case value={ProductTypes.ALASKA529}>
            <div
              className={`${
                scsProgram
                  ? newFundSearchChosenAgreement
                  : newFundSearchProspectus
              }`}
            >
              I have reviewed the{' '}
              <a
                href="https://www.alaska529plan.com/content/dam/alaska529/forms/Plan_Disclosure.pdf"
                className="college-branded-link"
                rel="noopener noreferrer"
                target="_blank"
              >
                Plan Disclosure Document's
              </a>{' '}
              description for the Portfolio(s) in which I am investing and agree
              to the terms.
            </div>
          </Case>
        </Switch>
      </If>
    </>
  );
};
export default NewFundSearchSelectedFundNotes;
